/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Unknown = 0, Company = 1, Customer = 2, Proximity = 3, Manual = 4
 */
export enum Routemize_Constants_SelectedSlotType {
    UNKNOWN = 'Unknown',
    COMPANY = 'Company',
    CUSTOMER = 'Customer',
    PROXIMITY = 'Proximity',
    MANUAL = 'Manual',
}
